import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { CHART } from "../routes";
import GlobalLoader from "./GlobalLoader";

type RouteParams = {
  redirectTo: string;
  chartId?: string;
};

export const CallbackPage = () => {
  const params = useParams<RouteParams>();
  const navigate = useNavigate();

  useEffect(() => {

    if (params.chartId) {
      navigate(CHART.replace(":chartId", params.chartId));
      return;
    }

    const redirectTo = `/${params.redirectTo || ""}`;
    navigate(redirectTo);
  }, [navigate, params]);

  return <GlobalLoader />;
};
